import { createSimpleFunctional } from '@/util'

export const VCardHeaderText = createSimpleFunctional('v-card-header-text')
